import { render } from "./index.vue?vue&type=template&id=66ed52fa"
import script from "./User.js?vue&type=script&lang=js"
export * from "./User.js?vue&type=script&lang=js"

import "./User.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script